import { SWRConfig } from "swr";

import { fetcherPost, fetcher } from "./../../../services/fetcher";
import { useAppDispatch } from "../../../hooks/useRedux";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../redux/features/snackbarSlice";

const ERROR_MESSAGES: Record<number, string> = {
  401: "ورود شما منقضی شده است. لطفاً مجدداً وارد شوید.",
  403: "دسترسی شما به این بخش مجاز نیست. لطفاً مجدداً وارد شوید.",
  404: "اطلاعات مورد نظر یافت نشد.",
  500: "خطای داخلی سرور. لطفاً چند لحظه دیگر مجدد تلاش کنید.",
  503: "سرویس موقتاً در دسترس نیست. لطفاً بعداً تلاش کنید.",
};

const SWRconfig = ({ children }: any) => {
  const dispatch = useAppDispatch();

  const handleError = (e: any) => {
    const response = e?.response;
    const status: number = response?.status ?? e?.request?.status ?? 0;

    if (!response && status === 0) {
      dispatch(setSnackbarErrorStatus(470));
      dispatch(
        setSnackbarDescription(
          "از اتصال خود به اینترنت مطمئن شوید و یا برای استفاده از خدمات بازارگاه لطفاً وی پی ان خود را خاموش کنید"
        )
      );
      dispatch(setOpenSnackbar(true));
      return;
    }

    const apiError: string | undefined = response?.data?.error;
    const apiCode: number | undefined = response?.data?.errorCode;
    const fallbackMessage = ERROR_MESSAGES[status] ?? "خطایی رخ داده است. لطفاً مجدد تلاش کنید.";

    dispatch(setSnackbarErrorStatus(apiCode ?? status));
    dispatch(setSnackbarDescription(apiError || fallbackMessage));
    dispatch(setOpenSnackbar(true));
  };

  return (
    <SWRConfig
      value={{
        // refreshInterval: 15000,
        revalidateOnFocus: false,
        errorRetryInterval: 800,
        errorRetryCount: 10,
        revalidateOnReconnect: true,
        onError: (e: any) => handleError(e),
        fetcher: fetcherPost,
      }}
    >
      {children}
    </SWRConfig>
  );
};
export default SWRconfig;
